import { axiosPost, axiosGet, axiosDelete, axiosPut } from '../axios/httpRequest';

/**
 * 用户登录
 * @param {string} idCarNo 身份证号码
 * @param {string} last6Word 密码身份证最后6位
 *
 */
export const userLoginApi = params => {
    return axiosPost('api/auth/v1/login', params);
};

export const userRegisterApi = params => {
    return axiosPost('api/auth/v1/register', params);
};

/**
 * 管理员登录
 * @param {string} no 账号
 * @param {string} password 密码
 *
 */
export const adminUserLoginApi = params => {
    return axiosPost('api/auth/v1/admin/login', params);
};

/**
 * 获取角色列表
 */
export const getRoleListApi = params => {
    return axiosGet(`api/auth/v1/role`, params);
};

/**
 * 新增角色
 */
export const postAddRoleApi = params => {
    return axiosPost(`api/auth/v1/role`, params);
};

/**
 * 获取角色权限列表
 */
export const getRoleAuthListApi = params => {
    return axiosGet(`api/auth/v1/role/${params.role_id}/auth`, params);
};

/**
 * 增加角色权限
 */
export const postAddRoleAuthApi = params => {
    return axiosPost(`api/auth/v1/role/${params.role_id}/auth/${params.auth_id}`, params);
};

/**
 * 删除角色权限
 */
export const delRoleAuthApi = params => {
    return axiosDelete(`api/auth/v1/role/${params.role_id}/auth/${params.auth_id}`, params);
};

/**
 * 查询接口列表
 */
export const getAuthListApi = params => {
    return axiosGet(`api/auth/v1/auth`, params);
};

/**
 * 查询权限详情
 */
export const getAuthDetailApi = params => {
    return axiosGet(`api/auth/v1/auth/${params.id}`, params);
};

/**
 * 修改接口权限配置
 */
export const putAuthDetailApi = params => {
    return axiosPut(`api/auth/v1/info/${params.id}`, params);
};
